export function formatScheduleUpdatedAt(value: string | null | undefined, now = new Date()): string | null {
  if (!value?.trim()) return null;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime()) || date.getTime() <= 0) return null;
  const hours = Math.floor((now.getTime() - date.getTime()) / 3_600_000);
  if (hours >= 0 && hours < 1) return 'Just now';
  if (hours >= 1 && hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  if (hours >= 24 && hours < 48) return 'Yesterday';
  return new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York' }).format(date);
}
